





















import Vue from 'vue';

export default Vue.extend({
    name: 'ModalControlsPanel',
    props: {
        /** Текст кнопки подтверждения */
        comfirmText: {
            type: String,
            default: 'Ок',
        },
        /** Текст кнопки отмены */
        canselText: {
            type: String,
            default: 'Отмена',
        },
        /** Прямая блокировка кнопки Confirm */
        disabledConfirm: {
            type: Boolean,
            default: false,
        },
        /** Обслуживает ли форма асинхронный запрос */
        isAsync: {
            type: Boolean,
            default: false,
        },
        /** Текст ошибки при неудаче запроса */
        aleartMessage: {
            type: String,
            default: 'Bad request. Please try again.'
        },
        /** Наличие активного асинхронного запроса */
        activeRequest: {
            type: Boolean,
        },
        /** Наличие ошибки запроса */
        failRequest: {
            type: Boolean,
        },
    },
    computed: {
        isShowAleart(): boolean {
            return this.isAsync === true && this.failRequest === true;
        },
        isBlockConfirm(): boolean {
            return this.disabledConfirm || this.isAsync === true && this.activeRequest === true;
        },
        isShowSpiner(): boolean {
            return this.isAsync === true && this.activeRequest === true;
        },
    },
    methods: {
        confirm(): void {
            this.$emit('confirm');
        },
        cansel(): void {
            this.$emit('cansel');
        },
    }
});
